export const CART_RESERVATION_MINUTES = 300
export const CART_RESERVATION_MS = CART_RESERVATION_MINUTES * 60 * 1000
